import Widget from "./base.js";
import spacetime from "spacetime";

export class Hive extends Widget {
	componentWillMount() {
		jQuery
			.ajax({
				method: "GET",
				url: `https://forums.${document.location.hostname}/latest.json`,
				dataType: "json",
				xhrFields: {
					withCredentials: true,
				},
				crossDomain: true,
			})
			.done((r) => {
				//⚠️ the topic_list.topics is empty sometimes. I'm not sure why.
				if (r.topic_list.topics.length > 0)
					this.setState({ topics: r.topic_list.topics });
			});
	}

	renderTopic(topic) {
		const d = spacetime(topic.last_posted_at);
		return (
			<a class="Hive__Topic" href={topic.url}>
				<div class="Hive__TopicTime">
					{d.monthName()}&nbsp;
					{d.date()}
				</div>
				<a
					href={`https://forums.${document.location.hostname}/t/${topic.slug}/${topic.id}`}
					class="Hive__TopicTitleAndCount"
				>
					<div class="Hive__TopicTitle">{topic.title}</div>
					<div class="Hive__TopicCount">{topic.posts_count}</div>
				</a>
			</a>
		);
	}

	renderContent() {
		const topics = this.state.topics;
		if (!topics) return;

		return (
			<div class="Hive__Inner">
				<a
					href={`${document.location.protocol}//forums.${document.location.hostname}`}
					class="Hive__Header"
				>
					<div class="Hive__Description">Member Exclusive</div>
					<div class="Hive__Title">
						THE HIVE
						<img
							class="Hive__Icon"
							src={`${document.location.protocol}//${document.location.hostname}/wp-content/themes/tpm25/assets/images/icons/hive_white.svg`}
							alt="The Hive Icon"
						/>
					</div>

					<img
						class="Hive__PrimeIcon"
						src={`${document.location.protocol}//${document.location.hostname}/wp-content/themes/tpm25/assets/images/logo/TPMRedes_PrimeLogo_Charcoal.svg`}
						alt="Prime Icon"
					/>
				</a>
				<div class="Hive__Border">
					<div class="Hive__ColumnNames">
						<div>TOP DISCUSSIONS</div>
						<div>COMMENTS</div>
					</div>
					{this.renderTopic(topics[0])}
					{this.renderTopic(topics[1])}
					{this.renderTopic(topics[2])}
					{this.renderTopic(topics[3])}
					{this.renderTopic(topics[4])}
				</div>
			</div>
		);
	}
}
